import * as types from '../mutation-define'
import {base_api} from '../../api/base_api';

const st_sysuser_key = "shop_info";
// const storage =  sessionStorage;
const storage =  localStorage;//

const state = {
	//{name:'调货申请', href:"#", percent:0, level:"success", }
      todo_task :[],
      notify    :[],
      messages  :[],

      detail    :null,
      user_name :"",
      user_id   :"",
      avatar    :"../static/avatars/user.jpg",
}

// getters
const getters = {
  	sysuser_info: function(state) {
  		if(state.detail) return state.detail;
      let user_info = sessionStorage.getItem(st_sysuser_key);
      if(user_info) {
        try{
          state.detail = JSON.parse(user_info);
        }catch(err){
          debugger
          msgpad_show("msgpad", "失败", err.message, 'error')
        }
      }
      return state.detail

  	},
    user_todo_task : state => state.todo_task,
    user_notify    : state => state.notify,
    user_messages  : state => state.messages,
}


// actions
const actions = {
    act_worker_login(context,{shop_id,sec_key,worker_id,password}){
      //{method,schema,params,data}
      // debugger
        return base_api({
          method:'post',
          schema:'login',
          params:{action:'ajaxlogin'},
          data:{
            shop_id,
            sec_key,
            worker_id,
            password
          }
        }).then(resp=>{
            return resp.data;
        })
    },
    act_worker_logout(context){
        return base_api({
          method:'get',
          schema:'login',
          params:{action:'ajaxlogout'},
        }).then(resp=>{
            
            return resp.data;
        })
    },

  act_user_message (context) {
  },

  req_user_todo_task (context) {
  },

  req_user_message (context) {
  },

  req_user_notify (context) {
  }
}

// mutations
const mutations = {
  [types.NAVBAR_USER_USER_INFO] (state, user_info) {
    	state.detail = user_info;
      sessionStorage.setItem(st_sysuser_key,JSON.stringify(user_info));
  },

  [types.NAVBAR_USER_TODO_TASK] (state,todo_task) {
     state.todo_task = todo_task ? todo_task:[];
  },

  [types.NAVBAR_USER_NOTIFY] (state,notify) {
     state.notify = notify ? notify:[];
  },

  [types.NAVBAR_USER_MESSAGE] (state,msg) {
     state.messages = msg ? msg:[];
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/sys_user/index.js